import { Reveal, Eyebrow } from "@/components/site/Primitives";
import { ASSETS, ABOUT, QUALIFICATIONS } from "@/data/site";

export const About = () => {
  return (
    <section id="ueber" className="relative py-24 lg:py-36 bg-cream">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* Portrait */}
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="overflow-hidden rounded-[2rem] ring-1 ring-gold/25">
                <img
                  src={ASSETS.portraitAbout}
                  alt="Andrea Rauh-Ambros"
                  className="w-full h-[30rem] lg:h-[38rem] object-cover object-[50%_28%]"
                />
              </div>
              <div className="absolute -top-6 -right-6 h-24 w-24 rounded-full border border-gold/40 hidden sm:block" />
              <div className="absolute bottom-6 left-6 bg-cream/90 backdrop-blur-md border border-gold/25 rounded-xl px-4 py-3">
                <p className="font-serif text-lg text-charcoal leading-none">Andrea Rauh-Ambros</p>
                <p className="text-[11px] uppercase tracking-widest text-gold-deep mt-1">Heilpraktikerin</p>
              </div>
            </div>
          </Reveal>
        </div>

        {/* Text */}
        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>Über mich</Eyebrow>
            <h2 className="mt-6 font-serif font-light tracking-tight text-charcoal text-4xl sm:text-5xl leading-tight">
              Erfahrung, Feingefühl und ein Blick für das Natürliche
            </h2>
            <p className="mt-8 text-lg text-charcoal leading-relaxed font-light">{ABOUT.lead}</p>
            <div className="mt-6 space-y-5 text-charcoal-soft leading-relaxed">
              {ABOUT.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <p className="mt-8 font-serif italic text-2xl text-gold-deep leading-snug">
              „{ABOUT.goal}"
            </p>
          </Reveal>

          {/* Qualifications timeline */}
          <Reveal delay={0.1}>
            <div className="mt-14">
              <Eyebrow>Ausbildung & Qualifikationen</Eyebrow>
              <ol className="mt-8 relative border-l border-gold/30 ml-1 space-y-7">
                {QUALIFICATIONS.map((q) => (
                  <li key={q.year} className="relative pl-8" data-testid={`qual-${q.year}`}>
                    <span className="absolute -left-[7px] top-1.5 h-3 w-3 rounded-full bg-gold ring-4 ring-cream" />
                    <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4">
                      <span className="font-serif text-xl text-gold-deep w-16 shrink-0">{q.year}</span>
                      <div>
                        <p className="text-charcoal font-medium">{q.title}</p>
                        <p className="text-sm text-charcoal-muted">{q.place}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ol>
              <p className="mt-8 text-sm text-charcoal-muted">
                Mitglied im Fachverband Deutscher Heilpraktiker e.V. · Mitgl.-Nr. 19597
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
